import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SnoozeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => {
	return (
		<svg
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<path
				d="M7 13.3333C10.6819 13.3333 13.6667 10.3485 13.6667 6.66667C13.6667 2.98477 10.6819 0 7 0C3.3181 0 0.333333 2.98477 0.333333 6.66667C0.333333 10.3485 3.3181 13.3333 7 13.3333Z"
				fill="#7c86ff"
			/>
			<path
				d="M7 3.33333V7.33333L9.66667 8.66667"
				className="stroke-white dark:stroke-black"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
})

export const SnoozeFilledIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => {
		return (
			<svg
				viewBox="0 0 14 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
				ref={ref}
			>
				<path
					d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0Z"
					fill="currentColor"
				/>
				<path
					d="M7 3.5V7.25L9.75 8.75"
					className="stroke-white dark:stroke-gray-900"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
			</svg>
		)
	},
)
